import {
  SingleMemberFirmCreationResponse,
  SingleMemberFirmCreationType,
} from '@bupa-kkv/features/company-creation/types';
import { queryKeyStore } from '@bupa-monorepo/shared-frontend/query-key-store';
import { useQuery } from '@tanstack/react-query';
import { getSelfEmploymentCreations } from '../../api/self-employment/get-self-employment-creations';

export const useGetSelfEmploymentCreations = (
  params: {
    type?: SingleMemberFirmCreationType;
  } | void
) => {
  return useQuery({
    queryKey: queryKeyStore.companyCreation.selfEmploymentCreations.queryKey,
    queryFn: getSelfEmploymentCreations,
    select: (data: SingleMemberFirmCreationResponse[]) =>
      data.find(
        ({ type }) =>
          type ===
          (params?.type ?? SingleMemberFirmCreationType.SOLE_PROPRIETORSHIP)
      ) ?? null,
  });
};
